import { createServerFn } from '@tanstack/react-start';

import { toPublicProject } from '@/content/schemas';

export const loadFeaturedProjects = createServerFn({ method: 'GET' }).handler(
  async () => {
    const { getFeaturedCaseStudies } = await import('./projects.server');
    return getFeaturedCaseStudies();
  }
);

export const loadPublishedProjects = createServerFn({ method: 'GET' }).handler(
  async () => {
    const { getPublishedProjects } = await import('./projects.server');
    return getPublishedProjects();
  }
);

export const loadProjectCaseStudy = createServerFn({ method: 'GET' })
  .validator((slug: string) => slug)
  .handler(async ({ data: slug }) => {
    const { getCaseStudyRecordBySlug } = await import('./projects.server');
    const { renderProjectMdxHtmlFromSource } = await import(
      './compile-mdx.server'
    );

    const record = getCaseStudyRecordBySlug(slug);
    if (!record?.sourcePath) {
      return null;
    }

    const project = toPublicProject(record);
    const bodyHtml = await renderProjectMdxHtmlFromSource(
      process.cwd(),
      record.sourcePath
    );

    return { project, bodyHtml };
  });
